/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {List} from "ionic-angular";
/**
 * Created by andrea on 2017-06-24.
 */

export abstract class EntryMetadata {
  // abstract listFromSnapshot(key: string, val: any) : Array<EntryMetadata>;

  constructor(public id: string, public name: string, public description: string) {

  }
}

// export interface MetadataSnapshot {
//   listFromSnapshot(key: string, val: any) : Array<EntryMetadata>;
// }



// WEBPACK FOOTER //
// ./src/models/schedule/metadata/EntryMetadata.ts